export enum PurchaseFlowRoutes {
  TRAVEL_DATE = 'travel-date',
  HOLDER_INFO = 'holder-info',
  TRAVEL_DURATION = 'travel-duration',
  QUOTE = 'quote',
  INSURANCE_RESULT = 'insurance-result',
}

export enum PolicyDownloadRoutes {
  SUCCESS = 'policy-download-success',
  LIST = 'policy-download-list',
  ERROR = 'policy-download-error',
}

export enum GeneralRoutes {
  ERROR = 'error',
  NOT_FOUND = 'not-found',
  NOT_FOUND_404 = 'not-found-404',
}

export enum LandingRoutes {
  VISITORS = 'visitors',
  POLICY_DOWNLOAD = 'policy-download',
}

export type AvailableRoutes =
  | PurchaseFlowRoutes
  | PolicyDownloadRoutes
  | GeneralRoutes
  | LandingRoutes
